import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router-dom';
import useAdminAutoArchiveMeetings from '@/backend/hooks/useAdminAutoArchiveMeetings.js';
import { ROUTES } from '@/routes/Routes.js';
import useDeviceSize from '@/services/hooks/useDeviceSize';
import EmptyPageWithTitle from '../page404/EmptyPageWithTitle.tsx';

/*
NOTE: This component contains code that should run on any page just like
the layout in nextjs. This is a good place to put global guards
*/
export const GlobalGuard = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceSize();
  const location = useLocation();

  const isMeetingStatsRoute = matchPath(
    { path: ROUTES.MEETING_STATS, end: false },
    location.pathname
  );

  useAdminAutoArchiveMeetings();

  if (isMobile && !isMeetingStatsRoute) {
    return <EmptyPageWithTitle title={t('mobileview.title')} subtitle="" />;
  }
  return children;
};
